document.addEventListener('DOMContentLoaded', () => {
  function restartVideos() {
    document.querySelectorAll('.product-media video').forEach(video => {
      video.play().catch(() => {});
    });
  }

  // Wenn zoom-dialog geschlossen wird
  document.addEventListener('click', (e) => {
    if (e.target.closest('.close-button') || e.target.closest('dialog')) {
      setTimeout(restartVideos, 300);
    }
  });

  // Wenn man zurück zur Seite navigiert (mobile browser)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) restartVideos();
  });

  // Pageshow (iOS Safari back button)
  window.addEventListener('pageshow', restartVideos);
});